import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Link } from "react-router-dom";
import { ArrowRight, MessageCircle, Phone, Mail, ExternalLink, Palette } from "lucide-react";
import { trackSocialClick } from "@/lib/analytics";
interface QuickActionsProps {
  className?: string;
  showTitle?: boolean;
}
const QuickActions = ({
  className = "",
  showTitle = true
}: QuickActionsProps) => {
  const contactActions = [{
    type: "link",
    href: "https://vk.com/im?sel=-214021218&entrypoint=community_page",
    label: "Написать в VK",
    icon: <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
          <path d="M12.785 16.241s.288-.032.435-.194c.135-.148.13-.427.13-.427s-.019-1.307.587-1.5c.595-.189 1.359 1.264 2.168 1.824.612.424 1.077.331 1.077.331l2.164-.03s1.132-.07.595-.96c-.044-.073-.312-.657-1.608-1.86-1.357-1.26-1.175-1.055.459-3.23.994-1.32 1.391-2.126 1.266-2.472-.119-.33-.852-.243-.852-.243l-2.438.015s-.18-.025-.314.056c-.13.078-.214.26-.214.26s-.383 1.02-.895 1.888c-1.08 1.83-1.512 1.926-1.688 1.812-.41-.265-.307-.106-.307-1.632 0-1.77.268-2.507-.523-2.696-.262-.063-.455-.105-1.126-.112-.863-.009-1.593.003-2.006.205-.275.134-.487.432-.358.45.159.022.52.098.711.359.247.337.238.109.238 1.684 0 .355-.067 1.697-.481 1.906-.284.143-.674-.149-1.511-1.846-.428-.846-.752-1.784-.752-1.784s-.062-.152-.174-.234c-.135-.098-.324-.129-.324-.129l-2.317.015s-.348.01-.475.161c-.113.134-.009.41-.009.41s1.797 4.207 3.828 6.328c1.862 1.944 3.977 1.816 3.977 1.816h.958z" />
        </svg>,
    color: "text-blue-500",
    bgColor: "bg-blue-500/10 hover:bg-blue-500/20 border-blue-500/20"
  }, {
    type: "link",
    href: "https://wa.me/89507818785",
    label: "WhatsApp",
    icon: <MessageCircle className="w-4 h-4" />,
    color: "text-green-500",
    bgColor: "bg-green-500/10 hover:bg-green-500/20 border-green-500/20"
  }, {
    type: "link",
    href: "https://t.me/FallenSonS",
    label: "Telegram",
    icon: <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
          <path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z" />
        </svg>,
    color: "text-blue-400",
    bgColor: "bg-blue-400/10 hover:bg-blue-400/20 border-blue-400/20"
  }];
  return <Card className={`border border-primary/20 bg-card/70 backdrop-blur-sm ${className}`}>
      <CardContent className="p-4 space-y-4">
        {showTitle && <div className="flex items-center gap-2">
            <Palette className="w-4 h-4 text-primary" />
            <span className="text-sm font-medium text-primary">Связаться с художником</span>
          </div>}

        <div className="space-y-2">
          {contactActions.map((action, index) => <a 
            key={index} 
            href={action.href} 
            target="_blank" 
            rel="noopener noreferrer" 
            onClick={() => trackSocialClick(action.label, 'quick_actions')}
            className={`flex items-center gap-3 p-3 rounded-xl border transition-all duration-300 group hover:scale-[1.02] ${action.color} ${action.bgColor}`}
          >
              <div className="group-hover:scale-110 transition-transform">
                {action.icon}
              </div>
              <span className="text-sm font-medium flex-1">{action.label}</span>
              <ExternalLink className="w-3 h-3 opacity-60 group-hover:opacity-100 transition-opacity" />
            </a>)}
        </div>

        

        
      </CardContent>
    </Card>;
};
export default QuickActions;